import ComposedChart from "./ComposedChart";

export default ComposedChart;
